
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Box-name',
    data () {
        return {
            estilos: {
                backgroundColor: '#faf0ca',
                // 'background-color': '#faf0ca',
                // background: '#faf0ca'
            }
        }
    }
})
